import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

import { preloadListInventoryTransfers } from '@/api/react-query'
import { paginatedSearchWithSort } from '@/utils/route-utilities'

const TRANSFER_STATUSES = ['DRAFT', 'IN_TRANSIT', 'RECEIVED', 'CANCELLED'] as const

export const Route = createFileRoute('/_authenticated/_general/inventory/transfers')({
	validateSearch: paginatedSearchWithSort(['lineCount', 'status']).extend({
		status: z.enum(TRANSFER_STATUSES).optional()
	}),
	loaderDeps: ({ search: { limit, offset, status, sortBy, sortOrder } }) => ({
		limit,
		offset,
		status,
		sortBy,
		sortOrder
	}),
	loader: async ({ context, deps: { limit, offset, status, sortBy, sortOrder } }) =>
		await preloadListInventoryTransfers(context, {
			query: { limit, offset, status, sortBy, sortOrder }
		}),
	staticData: {
		crumb: ({ context: { L } }) => L.Inventory.Transfers()
	}
})
